<div class="route-component">
    <div class="search-component">
        <h4>
            Clients
        </h4>

        <div class="line-connector"></div>

        <div class="action-bar">
            <div class="action-bar right">
                <div class="action-container">
                    <button *hasPermission="['Client', 'Create']" (click)="upsertClient(0)">
                        Add <i class="fas fa-plus"></i>
                    </button>
                    <button *hasPermission="['Client', 'Export']" (click)="downloadClients(paging)">
                        Download <i class="fas fa-download"></i>
                    </button>
                </div>
            </div>
        </div>

        <div class="search-bar">
            <div class="search-bar left">
                <div class="search-container">
                    <input class="search-input" type="text" placeholder="Search..." [(ngModel)]="search" (keydown.enter)="refreshGridData()">
                    <button class="search-button" (click)="refreshGridData()">
                        <i class="fas fa-magnifying-glass"></i>
                    </button>
                </div>
            </div>
        </div>

        <pageable-table
            [items]="clients"
            [paging]="paging"
            [columns]="getColumnMap()"
            (refreshData)="getClients($event)"
            [showEdit]="showEdit || false"
            (editItem)="upsertClient($event)"
            [showDelete]="showDelete || false"
            (deleteItem)="deleteClient($event)">
        </pageable-table>
    </div>
</div>